
export function waitForDependency(waitForType, callback, args){
	switch(waitForType) {
		case 'slick':
			waitForSlick(callback, args);
			break;
		case 'sweetalert':
			waitForWindowVariable('Swal',callback, args);
			break;
		case 'photoswipe':
			waitForWindowVariable('PhotoSwipe',callback, args);
			break;
		case 'magnificPopup':
			waitForMagnificPopup(callback, args);
			break;
		case 'vue':
			waitForWindowVariable('Vue',callback, args);
			break;
		case 'dayjs':
			waitForWindowVariable('dayjs',callback, args);
			break;
		case 'swiper':
			waitForWindowVariable('Swiper',callback, args);
			break;
        case 'moment':
            waitForWindowVariable('moment',callback, args);
            break;
	}
}

function waitForWindowVariable(variable,callback,args){
	if(typeof window[variable] !== 'function')
	{
		let attempts = 0;
		const waitInterval = setInterval(function(){
			if(typeof window[variable] === 'function')
			{
				clearInterval(waitInterval);
				handleCallback(callback, args);
			}
			else
			{
				attempts++;
				if(attempts > 100)
				{
					clearInterval(waitInterval);
					console.log(variable+' took too long to load');
				}
			}
		},100);
	}
	else
	{
		handleCallback(callback, args);
	}
}

function waitForMagnificPopup(callback, args)
{

	if(typeof $().magnificPopup !== 'function')
	{
		let attempts = 0;
		const waitInterval = setInterval(function(){
			if(typeof $().magnificPopup === 'function')
			{
				clearInterval(waitInterval);
				handleCallback(callback, args);
			}
			else
			{
				attempts++;
				if(attempts > 20)
				{
					clearInterval(waitInterval);
					console.log('magnificPopup took too long to load');
				}
			}
		},100);
	}
	else
	{
		handleCallback(callback, args);
	}
}

function waitForSlick(callback, args)
{
	if(typeof $.fn.slick !== 'function')
	{
		let attempts = 0;
		const waitInterval = setInterval(function(){
			if(typeof $.fn.slick === 'function')
			{
				clearInterval(waitInterval);
				handleCallback(callback, args);
			}
			else
			{
				attempts++;
				if(attempts > 20)
				{
					clearInterval(waitInterval);
					console.log('Slick took too long to load');
				}
			}
		},100);
	}
	else
	{
		handleCallback(callback, args);
	}
}

function handleCallback(callback, args)
{
	if(typeof callback === 'function') {
		if (typeof args !== 'undefined') {
			callback.apply(this, args);
		}
		else {
			callback();
		}
	}
}
